import { chain } from '@leprecoins/effector';
import { createForm } from '@leprecoins/effector-forms';
import { sample } from 'effector';
import { createDeleteDeviceDetailedModel } from 'features/delete-device';
import { DEVICE_NAME_MAX_LENGTH, DEVICE_NAME_MIN_LENGTH } from 'entities/device';
import { createEditDeviceDetailedMutation } from 'shared/api';
import { maxLengthRule, minLengthRule, notEmptyRule, notify } from 'shared/lib';
import { authorizedDeviceRoute, router } from 'shared/routing';
import { devicePageModel } from './device-page-model';

const deleteDeviceModel = createDeleteDeviceDetailedModel();

const editDeviceMutation = createEditDeviceDetailedMutation();

const form = createForm({
	fields: {
		name: {
			init: '',
			rules: [
				notEmptyRule,
				minLengthRule(DEVICE_NAME_MIN_LENGTH),
				maxLengthRule(DEVICE_NAME_MAX_LENGTH),
			],
		},
		account: {
			init: '',
		},
		cashdesk: {
			init: '',
		},
		game: {
			init: '',
		},
		currency: {
			init: '',
		},
		pin: {
			init: '',
		},
		players: {
			init: '',
		},
		status: {
			init: false,
		},
	},
	validateOn: ['submit'],
	resetErrorsOnChange: true,
});

sample({
	clock: devicePageModel.getDeviceInfoQuery.finished.success,
	fn: ({ result }) => ({
		name: result.name,
		account: result.account.name,
		cashdesk: result.cashdesk.name,
		game: result.game.title,
		currency: result.currency,
		pin: result.cashdeskCode,
		players: result.players,
		status: result.isActive,
	}),
	target: [form.setValues, form.setInitialValues],
});

sample({
	clock: form.submitted,
	source: { device: devicePageModel.$device, values: form.$values },
	filter: ({ device }) => device !== null,
	fn: ({ device, values }) => ({
		id: device?.id ?? 0,
		name: values.name,
	}),
	target: editDeviceMutation.start,
});

notify(editDeviceMutation.finished.success, 'device-page.edit-success');

sample({
	clock: [editDeviceMutation.finished.success],
	source: devicePageModel.$device,
	filter: Boolean,
	fn: ({ id }) => id,
	target: devicePageModel.getDeviceInfoQuery.start,
});

chain(deleteDeviceModel.mutation.finished.success, router.back);

sample({
	clock: authorizedDeviceRoute.closed,
	target: [form.reset, editDeviceMutation.reset],
});

export const devicePageInfoModel = {
	deleteDeviceModel,
	form,
	editDeviceMutation,
};
